import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserLogin = {
  userLogin: { data: null, loading: false, error: null },
};

export const userLogin = createAsyncThunk('user/userLogin', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/login`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserLogin = {
  [userLogin.pending]: (state) => {
    state.userLogin.loading = true;
  },
  [userLogin.fulfilled]: (state, action) => {
    state.userLogin.loading = false;
    state.userLogin.data = action.payload;
    state.userLogin.error = null;
  },
  [userLogin.rejected]: (state, action) => {
    state.userLogin.loading = false;
    state.userLogin.error = action.payload;
  },
};
